import React__default from 'react';
import styled from 'styled-components';
import { T as Tooltip } from '../Tooltip/Tooltip-CcE59QOX.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BGx4v_Uj-CJNeXUZQ.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { h as attach } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { F as FileUploadButton } from '../FileUpload/FileUploadButton/index-qgv1fNWM.js';

const StyledUploadButton = /*#__PURE__*/styled(FileUploadButton).withConfig({
  componentId: "sc-storm-ui-30060407__sc-14kgr2c-0"
})(["&& + div > button{display:flex;justify-content:center;align-items:center;height:20px;width:20px;padding:unset;:hover{background:none;}> i{color:", ";}}"], ({
  theme
}) => theme.palette.gray[500]);
const FileAttachmentButton = ({
  id,
  onChange,
  disabled,
  acceptedAttachmentTypes
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'attachment-button'
  });
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    nonInteractive: true,
    inert: disabled,
    trigger: /*#__PURE__*/React__default.createElement("span", {
      "aria-label": formatMessage({
        id: 'action-attach'
      })
    }, /*#__PURE__*/React__default.createElement(StyledUploadButton, {
      buttonProps: {
        ...getDataTaktAttributes()
      },
      transparent: true,
      inputId: id,
      label: "",
      hideLabel: true,
      icon: attach,
      onChange: onChange,
      disabled: disabled,
      multiple: true,
      accept: acceptedAttachmentTypes
    })),
    message: formatMessage({
      id: 'action-attach'
    })
  });
};

export { FileAttachmentButton as F };
//# sourceMappingURL=FileAttachmentButton-DxXtpJo1.js.map
